module.exports = __webpack_public_path__ + "static/media/property-managers-11.a79a241a.svg";